export function initMenus() {
	initMobileMenu()
}

function initMobileMenu() {
	const triggers = Array.from(document.getElementsByClassName('mobile-menu-trigger')) as HTMLElement[]
	const menu = document.getElementById('mobileMenu')

	function toggleMobileMenu() {
		triggers.forEach(el => el?.classList.toggle('open'))
		menu?.classList.toggle('open')
	}

	triggers.forEach(el => el?.addEventListener('pointerdown', toggleMobileMenu))
}